// A page whose content the server wrote as HTML (the keyword landing pages,
// the property-searches hub): it gets the site's header, footer and theme
// around it, and keeps its own content exactly as written.
export default function Raw({ data }) {
  return <div className="raw-page" dangerouslySetInnerHTML={{ __html: data.html || '' }} suppressHydrationWarning />;
}
